import React from 'react';
import InternalExternalLink from '.';
import { Link as LinkInterface } from '../../interfaces/link';

interface InternalExternalLinksProps {
  data: {
    extraClasses: string;
    links: Array<LinkInterface>;
  };
}

function InternalExternalLinks({ data }: InternalExternalLinksProps) {
  const { links, extraClasses } = data;

  return (
    <div className={`${extraClasses ? extraClasses : ''}`}>
      {links &&
        links.map((link, index: number) => {
          return <InternalExternalLink link={link} key={index} />;
        })}
    </div>
  );
}

export default InternalExternalLinks;
